<template>
  <protection-base :product="product">
    <img
      v-for="(brochure, index) in productBrochures"
      :key="index"
      :src="brochure.link"
      :alt="brochure.label"
      class="w-100"
      data-test="image"
    />
  </protection-base>
</template>

<script>
import ProtectionBase from '@/modules/spotlight/components/categories/protection/ProtectionBaseWithVendorLogo.vue';

export default {
  name: 'ProtectionProductBrochure',
  components: {
    ProtectionBase,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    productBrochures() {
      return Object.prototype.hasOwnProperty.call(this.product.payload, 'brochureLinks')
        ? this.product.payload.brochureLinks
        : [];
    },
  },
};
</script>

<style scoped></style>
